/** Company status values used in list filters and UI labels */
export const COMPANY_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  PENDING: 'PENDING',
};

/** Sum shareholding % for Etisalat group entities in a shareholder list */
export const calculateEtisalatOwnership = (shareholders) => {
  if (!shareholders || !Array.isArray(shareholders)) return 0;

  const isEtisalatShareholder = (sh) => {
    if (sh.isEtisalatEntity || sh.is_etisalat_entity === 1 || sh.is_etisalat_entity === true) {
      return true;
    }
    const name = String(sh.shareholderName || sh.name || '').toLowerCase();
    return name.includes('etisalat') || name.includes('e&') || name.includes('emirates telecom');
  };

  return shareholders
    .filter(isEtisalatShareholder)
    .reduce((sum, sh) => sum + (Number(sh.percentage) || 0), 0);
};
